import React, { useEffect, useContext } from "react";
import { Modal, Form, Input } from "antd";
import { useAtom } from "jotai";
import { visibleModalContactoEmergenciaAtom } from "pages/movil/PerfilMovilStore";
import { SecurityContext } from "context/SecurityContextProvider";
import { PortalColaboradorService } from "services/PortalColaboradorService";

const ModalEditarContactoEmergencia = ({ colaborador, setColaborador }) => {
	const [visibleModal, setVisibleModal] = useAtom(visibleModalContactoEmergenciaAtom);
	const [formulario] = Form.useForm();
	const { getUsuarioAutenticado } = useContext(SecurityContext);

	useEffect(() => {
		const cargarDatos = async () => {
			formulario.setFieldsValue({
				contactoEmergencia: {
					nombres: colaborador?.contactoEmergencia?.nombres,
					telefono: colaborador?.contactoEmergencia?.telefono,
				},
			});
		};

		cargarDatos();
	}, [colaborador]);

	const handleCancel = async () => {
		setVisibleModal(false);
		formulario.resetFields();
	};
	const handleActualizarContactoEmergencia = async (colaborador) => {
		colaborador.datosPersonales = {
			numeroDocumentoIdentidad: getUsuarioAutenticado().numeroDocumentoIdentidad,
		};
		await PortalColaboradorService.actualizarContactoEmergencia(colaborador);
		const response = await PortalColaboradorService.buscarColaborador();
		setColaborador(response);
		handleCancel();
	};
	return (
		<Modal
			title="Editar Contacto Emergencia"
			open={visibleModal}
			onOk={() => formulario.submit()}
			onCancel={handleCancel}
		>
			<Form
				layout="horizontal"
				labelCol={{
					span: 4,
				}}
				wrapperCol={{
					span: 20,
				}}
				form={formulario}
				onFinish={handleActualizarContactoEmergencia}
				initialValues={{
					contactoEmergencia: {
						nombres: colaborador?.contactoEmergencia?.nombres,
						telefono: colaborador?.contactoEmergencia?.telefono,
					},
				}}
			>
				<Form.Item
					label="Nombre"
					name={["contactoEmergencia", "nombres"]}
					rules={[
						{
							required: true,
						},
					]}
				>
					<Input />
				</Form.Item>
				<Form.Item
					label="Teléfono"
					name={["contactoEmergencia", "telefono"]}
					rules={[
						{
							required: true,
						},
					]}
				>
					<Input />
				</Form.Item>
			</Form>
		</Modal>
	);
};
export default ModalEditarContactoEmergencia;
